import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LearningStyleCard = ({ title, percentage, description, examples, color }) => {
      const { t, i18n } = useTranslation();
      const [isHovered, setIsHovered] = useState(false);
      
      const percentageText = percentage <= 30 ? "LOW" : (percentage > 30 && percentage < 65) ? "Moderate" : percentage > 65 ? "High" : "-"
  return (
    <CardContainer color={color}>
      <Title>
        {t(title) } <Percentage color={color}>{t(percentageText) }</Percentage>
      </Title>
      <Description>{t(description) }</Description>
      <ProgressBarContainer 
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
      >
        <ProgressBar color={color} percentage={percentage}>
          <ProgressIndicator percentage={percentage} color={color} />
        </ProgressBar>
        {isHovered && <PercentageTooltip percentage={percentage}>{percentage}%</PercentageTooltip>}
      </ProgressBarContainer>
      <ExamplesTitle>{t("Examples") + ":"}</ExamplesTitle>
      <ExamplesList>
        {examples.map((example, index) => (
          <li key={index}>{t(example)}</li>
        ))}
      </ExamplesList>
    </CardContainer>
  );
};

export default LearningStyleCard;

// Styled Components
const getColor = (percentage) => {
  if (percentage < 30) return "#FF4D4D"; // Red for Low
  if (percentage <= 65) return "#FFB422"; // Orange for Moderate
  return "#45C952"; // Green for High
};

const PercentageTooltip = styled.div`
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${(props) => getColor(props.percentage)};
  color: black;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 2;
`;

const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const Percentage = styled.span`
  color: #CA4481;
  font-weight: bold;
  font-size: 1.1rem;
`;

const ProgressBar = styled.div`
  height: 100%;
  background-color: ${(props) =>
    props.percentage < 30
      ? "#FF4D4D !important"
      : props.percentage <= 65
      ? "#FFB422 !important"
      : "#45C952 !important"};
  width: ${(props) => props.percentage}%;
  position: relative;
  z-index: 0;
  border-radius: 15px;
`;

const ProgressIndicator = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${(props) =>
    props.percentage < 30
      ? "#FF4D4D !important"
      : props.percentage <= 65
      ? "#FFB422 !important"
      : "#45C952 !important"};
  border: 5px solid white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -8px; // Positions the indicator at the end of the filled progress bar
   z-index: 1
`;

const CardContainer = styled.div`
  background-color: white; // Consistent background color for all cards
  padding: 20px;
  border-radius: 8px;
  flex: 1;
  margin: 10px;
  max-width: 350px;

  &:hover {
    background-color: #FFE8F2;
    border-left: 3px solid #8F305C;
  }

  &:hover ${Percentage} {
    color: #8F305C; // Change the color of Percentage on hover
  }

  &:hover ${ProgressIndicator} {
    background-color: #8F305C
  }

  &:hover ${ProgressBar} {
  background-color: #8F305C
  }
`;

const Description = styled.p`
  font-size: 0.9rem;
  margin-top: 10px;
  text-align: justify;
  min-height: 130px;
`;

const ProgressBarContainer = styled.div`
  background-color: #EBEBEB;
  height: 16px;
  border-radius: 15px;
  margin-top: 15px;
//   overflow: hidden;
  position: relative;
`;



const ExamplesTitle = styled.h4`
  font-size: 1rem;
  font-weight: bold;
  margin-top: 20px;
`;

const ExamplesList = styled.ul`
  font-size: 0.9rem;
  margin-top: 5px;
  padding-left: 20px;
  list-style-type: disc;
`;
